<template>
    <common-modal :width="'large'" :height="'medium'" :showAsInnerModal="showAsInnerModal" @close="emitEvent({ name: 'close' })">
        <direct-referral-form
            :user="user"
            :ehr="ehr"
            :insurancePlanId="insurancePlanId"
            :existingReferral="existingReferral"
            :activePracticeType="activePracticeType"
            :showAsInnerModal="showAsInnerModal"
            :patientId="patientId"
            @emitEvent="emitEvent($event)"
        ></direct-referral-form>
    </common-modal>
</template>

<script>
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import DirectReferralForm from 'components/page-elements/referrals/DirectReferralForm'

    export default {
        components: { DirectReferralForm },

        props: {
            user: { type: Object, default: null },
            insurancePlanId: { type: Number, default: null },
            existingReferral: { type: Object, required: false, default: null },
            activePracticeType: { type: String, default: PracticeTypeEnum.PHYSICIAN },
            showAsInnerModal: { type: Boolean, default: false },
            ehr: { type: Boolean, default: false },
            patientId: { type: Number, default: null, required: false },
        },

        watch: {
            $route() {
                if (this.$route.name === 'referrals.new.make') {
                    this.emitEvent({ name: 'close' })
                }
            },
        },
    }
</script>

<style lang="scss">
    @import 'styles/components/referrals/_app-direct-referral';
</style>
